import { LogementModel } from './logement.model';


export class RattachementLogementModel {

    flgColocation: boolean;
    logement: LogementModel;
}
